const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Holideviser Knowledge Library — public read access.
export async function fetchRecommendations({ destination, category, verification_status } = {}) {
  const params = new URLSearchParams();
  if (destination) params.set("destination", destination);
  if (category) params.set("category", category);
  if (verification_status) params.set("verification_status", verification_status);
  const qs = params.toString();
  const res = await fetch(`${BASE}/recommendations${qs ? `?${qs}` : ""}`);
  if (!res.ok) throw new Error("Failed to load recommendations");
  const data = await res.json();
  return data.recommendations || [];
}
